module.exports = __webpack_public_path__ + "img/coach-avatar-example@2x.eb9fdd0d.png";